export function registerChartTheme01() {
  echarts.registerTheme('theme-chart01', {
    backgroundColor: 'transparent',
    color: ['#ffffff', '#cccccc', '#999999'],
    textStyle: {
      color: '#ffffff'
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      textStyle: {
        color: '#ffffff'
      }
    },
    axisPointer: {
      lineStyle: {
        color: '#ffffff',
        type: 'dashed'
      }
    },
    pie: {
      label: {
        color: '#ffffff',
        fontSize: 14,
        lineHeight: 20
      },
      labelLine: {
        lineStyle: {
          color: '#ffffff'
        }
      },
      itemStyle: {
        borderColor: '#005794',
        borderWidth: 2
      }
    },
    line: {
      symbolSize: 8,
      itemStyle: {
        color: '#ffffff'
      },
      lineStyle: {
        color: '#ffffff',
        width: 2
      },
      areaStyle: {
        color: 'rgba(255,255,255,0.2)'
      }
    },
    radar: {
      axisName: {
        color: '#ffffff',
        fontSize: 12
      },
      axisLine: {
        lineStyle: {
          color: '#ffffff'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0.3)'
        }
      },
      splitArea: {
        areaStyle: {
          color: ['transparent']
        }
      }
    },
    categoryAxis: {
      axisLine: {
        lineStyle: {
          color: '#ffffff'
        }
      },
      axisLabel: {
        color: '#ffffff'
      },
      splitLine: {
        show: false
      }
    },
    valueAxis: {
      axisLine: {
        lineStyle: {
          color: '#ffffff'
        }
      },
      axisLabel: {
        color: '#ffffff'
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0.2)'
        }
      }
    },
    legend: {
      textStyle: {
        color: '#ffffff'
      }
    }
  });
}